import { useCallback } from 'react';
import { GIVE_NOW_SESSION_STORAGE_KEY } from '../constants';
import type { SessionStorageGiveNow } from '../useGiveNowSessionStorage';
import { useValidatedGives } from './useValidatedGives';

export const useValidatedGiveNowStructure = () => {
  const validatedGives = useValidatedGives();
  return useCallback((): SessionStorageGiveNow => {
    try {
      const sessionStorageValue = sessionStorage.getItem(GIVE_NOW_SESSION_STORAGE_KEY);
      if (!sessionStorageValue) {
        return {};
      }
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
      const giveNow = JSON.parse(sessionStorageValue);
      if (typeof giveNow !== 'object' || giveNow === null) {
        return {};
      }

      const validatedGiveNow: SessionStorageGiveNow = {};
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
      for (const [viewerId, giving] of Object.entries(giveNow)) {
        if (typeof viewerId === 'string' && Array.isArray(giving)) {
          validatedGiveNow[viewerId] = validatedGives(giving);
        }
      }

      return validatedGiveNow;
    } catch {
      return {};
    }
  }, [validatedGives]);
};
